"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    paddingTiny: '0 8px',
    paddingSmall: '0 10px',
    paddingMedium: '0 12px',
    paddingLarge: '0 14px',
    clearSize: '16px'
};
